import React from 'react';
import Layout from "../../components/layout/Layout";

const Home = () => {
  return (
    <Layout disableHead={true}>
      <div style={{ position: 'relative', width: '100%', height: '100vh' }}>
        <iframe
          title="Dashboard Power BI"
          src="https://app.powerbi.com/view?r=eyJrIjoiYjg5Zjk1MmYtYjU5MC00ZTMyLWI0YzEtZjc3ZDE0YjI2MTA3IiwidCI6IjM2MTA2MzViLWM0ZTItNGY3MC1iMjc2LTM1Nzg3Nzc3ZDg1ZCIsImMiOjR9&pageName=d4d6c95be0cca0171ac2"
          style={{ width: '100%', height: '100%', border: 'none' }}
          allowFullScreen
        />
        {/* Cubre "Microsoft Power BI" en la esquina inferior izquierda */}
        <div
          style={{
            position: 'absolute',
            bottom: 0,
            left: 0,
            width: '200px',
            height: '44px',
            background: '#ffffff',
            zIndex: 1,
          }}
        />
        {/* Cubre los iconos de compartir y pantalla completa en la esquina inferior derecha */}
        <div
          style={{
            position: 'absolute',
            bottom: 0,
            right: 0,
            width: '72px',
            height: '44px',
            background: '#ffffff',
            zIndex: 1,
          }}
        />
      </div>
    </Layout>
  );
};

export default Home;
